<p-dialog [(visible)]="showNewAppConfirmation" (onHide)="hide()" [style]="{ width: '35rem' }" [focusTrap]="true" [modal]="true">
  <div class="message-container" *ngIf="confirmationModalService.message">
    {{ confirmationModalService.message() }}
  </div>
  <div class="buttons-container">
    <p-button [label]="'yes-button-label' | translate" severity="secondary" (click)="accept()"></p-button>
    <p-button [label]="'no-button-label' | translate" (click)="reject()"></p-button>
  </div>
</p-dialog>
